import React, { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUnmount } from 'react-use';
import { useHistory } from 'react-router';

import Form, {
  FormField,
  xcriticalFormError,
  formSelector,
  xcriticalFormDelete,
  xcriticalFormInit,
} from '@xcritical/forms';
import Button from '@xcritical/button';

import { InputFormField } from '@crm-framework/form-fields';
import { Spacing } from '@crm-framework/spacing';

import { checkTokenRequestAction } from '../actions';
import { TOKEN_FORM } from '../consts';

import { Logo, FlexContainerCenter, TokenWrapper } from './styled';

export const TokenAuth: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { model } = useSelector((state) =>
    formSelector<Record<string | number, any>>(state, TOKEN_FORM)
  );

  useMount(() => {
    if (!model.token) dispatch(xcriticalFormInit(TOKEN_FORM, { token: null }));
  });

  useUnmount(() => dispatch(xcriticalFormDelete(TOKEN_FORM)));

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();

    if (model.token) {
      history.push(`/?token=${model.token}`);
      dispatch(checkTokenRequestAction());
    } else {
      dispatch(xcriticalFormError(TOKEN_FORM, { token: 'Please add token' }));
    }
  };

  return (
    <TokenWrapper>
      <Logo />
      <Form name={TOKEN_FORM} onSubmit={handleSubmit}>
        <FlexContainerCenter>
          <FormField
            name="token"
            placeholder="Enter the token"
            shouldFitContainer
            component={InputFormField}
          />
          <Spacing ml={5}>
            <Button
              type="button"
              appearance="primary"
              disabled={!model.token}
              onClick={handleSubmit}>
              Submit
            </Button>
          </Spacing>
        </FlexContainerCenter>
      </Form>
    </TokenWrapper>
  );
};
